"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_75_36_0 = void 0;
/**
 * Migrate to 75.36.0
 *
 * Adds proper StrainReliefSeparatorRefs for espools.
 */
const migration_75_36_0 = (json) => {
    var _a, _b;
    // We only had one specific article in data of schemaVersion "1" that has to be considered here.
    const strainReliefSeparatorRef = '21.1.Z.1';
    if (!((_b = (_a = json.Espool) === null || _a === void 0 ? void 0 : _a.LinearKette) === null || _b === void 0 ? void 0 : _b.IaRefs))
        return json;
    const iarefs = json.Espool.LinearKette.IaRefs;
    if (iarefs.includes(strainReliefSeparatorRef)) {
        json.Espool.LinearKette.StrainReliefSeparatorRefs = [strainReliefSeparatorRef];
        json.Espool.LinearKette.IaRefs = json.Espool.LinearKette.IaRefs.filter((ia) => ia !== strainReliefSeparatorRef);
    }
    return json;
};
exports.migration_75_36_0 = migration_75_36_0;
//# sourceMappingURL=migration_75_36_0.js.map